module.exports = __webpack_public_path__ + "static/media/lalamove.f978c66c.png";